<template>
  <collapse>
    <template v-if="hasError === true">
      <div :class="props.textClassList ? props.textClassList : 'error form-text font-weight-midbold'">
        <template v-for="error in errorMessages">
          <div v-if="typeof error !== 'object'">
            <template v-if="$slots.default">
              <slot name="default" :error="error"/>
            </template>

            <template v-else>
              <div :class="props.textClassList ? '' : 'error__message'" :key="error">
                {{ error }}
              </div>
            </template>
          </div>
        </template>
      </div>
    </template>
  </collapse>
</template>

<script setup>
  import Collapse from '@/components/transitions/collapse';
  import { useFieldErrors } from '@/composables/form/field-errors';
  import { toRef } from 'vue';

  const props = defineProps({
    errors: {
      type: Object,
      default: null,
    },
    errorName: {
      type: [String, Array],
      default: null,
    },
    textClassList: {
      type: Array,
      default: null,
    }
  });

  const { hasError, errorMessages } = useFieldErrors(props.errors, toRef(() => props.errorName));
</script>
